var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3766 11.8643C30.7671 11.4737 30.7671 10.8406 30.3766 10.4501L29.5503 9.62385C29.1598 9.23333 28.5267 9.23333 28.1361 9.62385L20.0003 17.7597L11.8645 9.62386C11.474 9.23333 10.8408 9.23333 10.4503 9.62385L9.6241 10.4501C9.23358 10.8406 9.23357 11.4737 9.6241 11.8643L17.7599 20.0001L9.6241 28.1359C9.23357 28.5264 9.23357 29.1596 9.6241 29.5501L10.4503 30.3763C10.8408 30.7668 11.474 30.7668 11.8645 30.3763L20.0003 22.2405L28.1361 30.3763C28.5267 30.7668 29.1598 30.7668 29.5503 30.3763L30.3766 29.5501C30.7671 29.1596 30.7671 28.5264 30.3766 28.1359L22.2407 20.0001L30.3766 11.8643Z",
    fill: "#FA4A6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/Reject.1b6465b3.svg";
export { ForwardRef as ReactComponent };